// extracted by mini-css-extract-plugin
export default {"error":"ErrorMessage_error__MR0Ic","detail":"ErrorMessage_detail__0lhAw"};